import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/visar',
    },
    {
      path: '/',
      name: 'inicio',
      component: () =>
        import(/* webpackChunkName: "about" */ './views/Inicio.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () =>
        import(/* webpackChunkName: "about" */ './views/Login.vue'),
    },
    {
      path: '/registro',
      name: 'registro',
      component: () =>
        import(/* webpackChunkName: "about" */ './views/Registro.vue'),
    },
    {
      path: '/nuevousuario',
      name: 'nuevoUsuario',
      component: () =>
        import(/* webpackChunkName: "about" */ './views/NuevoUsuario.vue'),
    },
    {
      path: '/perfil',
      name: 'perfil',
      component: () =>
        import(/* webpackChunkName: "about" */ './views/Perfil.vue'),
    },
    {
      path: '/visar',
      name: 'visar',
      component: () =>
        import(/* webpackChunkName: "about" */ './views/Visar.vue'),
    },
    {
      path: '/nuevoDispositivo',
      name: 'nuevoDispositivo',
      component: () =>
        import(/* webpackChunkName: "about" */ './views/NuevoDispositivo.vue'),
    },
    {
      path: '/usuarios',
      name: 'usuarios',
      component: () =>
        import(/* webpackChunkName: "about" */ './views/admin/Usuarios.vue'),
    },
    {
      path: '/automatismo',
      name: 'automatismo',
      component: () =>
        import(/* webpackChunkName: "about" */ './views/admin/automatismo.vue'),
    },
    {
      path: '/agenda',
      name: 'agenda',
      component: () =>
      import(/* webpackChunkName: "about" */ './views/Agenda.vue'),
    },
  ],
});
